<template>
	<div class="empty-state">
		<div class="image">
			<img
					v-if="image === 'empty-dashboard'"
					alt=""
					height="104"
					src="~/assets/images/empty-dashboard.png"
					width="91"
			/>
			<img
					v-if="image === 'no-ries'"
					alt=""
					src="~/assets/images/no-ries.png"
					width="127"
					height="76"
			/>
		</div>
		<div class="text">
			<h2>{{ title }}</h2>
			<p v-if="description">{{ description }}</p>
		</div>
		<slot></slot>
	</div>
</template>
<script lang="ts" setup>

	import type {PropType} from 'vue';

	defineProps({
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
			default: ''
		},
		image: {
			type: String as PropType<'no-ries' | 'empty-dashboard' | undefined>,
			required: false,
			default: undefined
		}
	});
</script>

<style scoped>
	.empty-state {
		display: grid;
		place-items: center;
		grid-template-columns: 1fr;
		grid-gap: 20px;
		padding: 40px 0;
		min-height: 25vh;
		text-align: center;
	}

	.image {
		min-height: 120px;

		display: grid;
		align-items: end;
		place-items: center;
	}

	p {
		color: var(--color-grey-300)
	}
</style>
